export type UserAgentType = "pc" | "mobile" | "ipad";

export function getUserAgentType(): UserAgentType {
    if (isIpad()) return "ipad"
    if (
        navigator.userAgent.match(/Mobi/i) ||
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/iPhone/i)
    ) {
        return "mobile";
    }
    return "pc";
}

export function isIpad() {
    const userAgent = navigator.userAgent;
    return /iPad|Macintosh/.test(userAgent) && "ontouchend" in document;
}

export function isMobile(): boolean {
    return getUserAgentType() === "mobile";
}

export function isIOS(): boolean {
    return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0
}

export function isAndroid(): boolean {
    return navigator.userAgent.toLowerCase().indexOf("android") >= 0
}

export function isWeiXin() {
    let ua = navigator.userAgent.toLowerCase();
    return ua.indexOf("micromessenger") >= 0;
}

export function isWxMini() {
    return window.location.href.toLowerCase().indexOf("wxmini") >= 0;
}

export function isQQ() {
    let ua = navigator.userAgent.toLowerCase();
    return ua.indexOf("qq") >= 0 && ua.indexOf("mqqbrowser") === -1;
}

export function isWeiXinOrQQ() {
    return isWeiXin() || isQQ()
}

export type AndroidBrand = "huawei" | "xiaomi" | "vivo" | "oppo" | "honor" | "unknown"

export function detectAndroidBrand(): AndroidBrand {
    let userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("huawei") > -1) {
        return "huawei";
    } else if (userAgent.indexOf("xiaomi") > -1 || userAgent.indexOf("redmi") > -1) {
        return "xiaomi";
    } else if (userAgent.indexOf("vivo") > -1) {
        return "vivo";
    } else if (userAgent.indexOf("oppo") > -1 || userAgent.indexOf("realme") > -1 || userAgent.indexOf("oneplus") > -1) {
        return "oppo";
    } else if (userAgent.indexOf("honor") > -1) {
        return "honor";
    } else {
        return "unknown";
    }
}